import React, { useCallback } from 'react';
import { Dropdown } from '../../../Dropdown';
export var FilterEditorEnumCondition = function FilterEditorEnumCondition(_ref) {
  var condition = _ref.condition,
      conditionType = _ref.conditionType,
      conditionValue = _ref.conditionValue,
      onConditionValueChange = _ref.onConditionValueChange;
  var label = condition.label,
      multiple = condition.multiple;

  var _conditionType$getAtt = conditionType.getAttributes(),
      options = _conditionType$getAtt.options;

  var _ref2 = conditionValue || {},
      value = _ref2.value;

  var onChange = useCallback(function (event) {
    onConditionValueChange({
      value: event.target.value
    });
  }, [onConditionValueChange]);
  return React.createElement(Dropdown, {
    wide: true,
    label: label,
    multiple: multiple,
    options: options,
    value: value || (multiple ? [] : ''),
    onChange: onChange
  });
};